import React from 'react';

const DataModal = ({ title, icon, data, onClose, renderItem, accentColor = '#00FFFF' }) => {
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999999,
        backdropFilter: 'blur(4px)'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          width: '90%',
          maxWidth: '600px',
          maxHeight: '80vh',
          background: 'rgba(10, 14, 39, 0.98)',
          border: `2px solid ${accentColor}40`,
          borderRadius: '16px',
          boxShadow: `0 0 40px ${accentColor}40`,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          margin: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '20px 25px',
          borderBottom: `2px solid ${accentColor}30`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(5, 7, 20, 0.6)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            fontSize: '18px',
            fontWeight: '700',
            color: accentColor
          }}>
            <span style={{ fontSize: '24px' }}>{icon}</span>
            <span>{title}</span>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#94a3b8',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '0',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.color = accentColor}
            onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '20px 25px'
        }}>
          {data && data.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {data.map((item, idx) => renderItem(item, idx))}
            </div>
          ) : (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#94a3b8',
              fontSize: '14px'
            }}>
              No data available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataModal;
